__turbopack_context__.v({
  "root": "ChatbotsPlanInfo-module__Kd9oHa__root",
  "separator": "ChatbotsPlanInfo-module__Kd9oHa__separator",
  "upgradeLink": "ChatbotsPlanInfo-module__Kd9oHa__upgradeLink",
});
